'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = require('./Utils');

var _SubContent = require('./Utils/SubContent');

var _SubContent2 = _interopRequireDefault(_SubContent);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIVE_MEBIBYTES = 5242880;

var FileUpload = function (_Component) {
    _inherits(FileUpload, _Component);

    function FileUpload() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FileUpload);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            progress: null
        }, _this.inputId = _this.props.id || (0, _Utils.generateId)(_this.props.name), _this._onFileChange = function (e) {
            if (e.target.files.length) {
                var file = e.target.files[0];

                if (file.size > _this.props.maxFilesize) {
                    _this.props.errorAction(_defineProperty({}, _this.props.name, ['The file size must be less than ' + _this.props.maxFilesizeHuman]));
                } else {
                    _this.setState({ progress: 0 });

                    _this.props.uploadAction(e.target.files[0], _this.props.data, function (value) {
                        _this.props.updateValue(_defineProperty({}, _this.props.name, value));
                        _this.setState({ progress: null });
                    }, function (progress) {
                        _this.setState({ progress: progress });
                    });
                }
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FileUpload, [{
        key: 'render',
        value: function render() {
            var groupClasses = (0, _classnames2.default)({
                'form__group': true,
                'form__group--error': this.props.errors && this.props.errors.length
            }, this.props.extraGroupClasses);

            var content = null;

            if (this.props.value) {
                content = _react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn--primary',
                        href: this.props.value,
                        target: '_blank'
                    },
                    'Download file'
                );
            } else {
                if (this.state.progress === null) {
                    content = _react2.default.createElement('input', {
                        accept: this.props.accept,
                        disabled: this.props.disabled,
                        onChange: this._onFileChange,
                        type: 'file'
                    });
                } else {
                    var style = {
                        width: Math.min(100, this.state.progress) + '%'
                    };

                    content = _react2.default.createElement(
                        'div',
                        { className: 'progress-bar' },
                        _react2.default.createElement('div', { className: 'progress-bar__meter', style: style })
                    );
                }
            }

            var control = _react2.default.createElement(
                'div',
                { className: 'form__control form__control--borderless' },
                content
            );

            if (this.props.controlOnly) {
                return control;
            }

            return _react2.default.createElement(
                'div',
                { className: groupClasses },
                _react2.default.createElement(
                    _Label2.default,
                    { htmlFor: this.inputId },
                    this.props.label
                ),
                control,
                _react2.default.createElement(_SubContent2.default, { errors: this.props.errors, help: this.props.help })
            );
        }
    }]);

    return FileUpload;
}(_react.Component);

FileUpload.propTypes = {
    accept: _propTypes2.default.string,
    controlOnly: _propTypes2.default.bool,
    data: _propTypes2.default.object,
    disabled: _Utils.formControlPropTypes.disabled,
    errorAction: _propTypes2.default.func.isRequired,
    errors: _Utils.formControlPropTypes.errors,
    extraGroupClasses: _propTypes2.default.arrayOf(_propTypes2.default.string),
    help: _Utils.formControlPropTypes.help,
    id: _propTypes2.default.string,
    label: _Utils.formControlPropTypes.label,
    maxFilesize: _propTypes2.default.number,
    maxFilesizeHuman: _propTypes2.default.string,
    name: _Utils.formControlPropTypes.name,
    updateValue: _Utils.formControlPropTypes.updateValue,
    uploadAction: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.string
};
FileUpload.defaultProps = {
    accept: 'application/pdf,image/png',
    controlOnly: false,
    data: {},
    disabled: false,
    help: _react2.default.createElement(
        'p',
        null,
        'Please upload a file in PDF/PNG format. ',
        'The file size must not exceed 5MB.'
    ),
    maxFilesize: FIVE_MEBIBYTES,
    maxFilesizeHuman: '5MB',
    value: null
};
exports.default = FileUpload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/FileUpload.js
// module id = 263
// module chunks = 0